<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <!--Report FORM-->
            <template v-if="type === 'form'">
                <v-toolbar-title >{{ formTitle }} </v-toolbar-title>
            </template>
            <!--Report VIEW TABLE-->
            <template v-if="type === 'view'">
                <v-toolbar-title>Reports Table</v-toolbar-title>
                <v-spacer></v-spacer>
                <responsiveButton setTo="/orgWorkSpace/report/add"
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                >
                    Add Report
                </responsiveButton>
            </template>
        </v-toolbar>
        <v-divider class="my-0 mx-6"></v-divider>
    </v-container>
</template>

<script>
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');

    export default {
        name: "ReportHeader",
        components:{responsiveButton},
        props:["hType", "tId"],
        data(){
            return{
                type: this.hType,
                id: null
            }
        },
        watch:{
            hType(value){
                this.type = value;
            },
            tId(value){
                this.id = value;
            }
        },
        computed:{
            formTitle () {
                return this.id? 'Clone report' : 'New report';
            },
        }
    }
</script>

<style scoped>

</style>